<template>
	<v-bottom-navigation
		height="38"
	 	dense
	 >
		<v-btn 
			text 
			:disabled="true"
		>
	    <span>
			{{ $ml.get('number_items') }}:
	    	{{pagination.items}}
	    </span>
		</v-btn>				    
		
     		<!-- class="col-md-4" -->
     	<v-pagination
	      	v-model 		= "page"					 
		    :length 		= "pagination.total"
		    :total-visible 	= "pagination.visible"
		    dense
	    ></v-pagination>

	    <v-menu 
	    	offset-y 
	    	top
	    >
    			<template v-slot:activator="{ on }">
                	<v-btn 
                		small 
                		v-on = "on" 
                	>
                		<v-tooltip bottom>
                			<template v-slot:activator="{ on }">
				        		<v-icon 
				        			small 
				        			v-on = "on"
				        		>
				        			mdi-grid
				        		</v-icon>
				        	</template>
				        	<span>
				        		{{ $ml.get('grid_options') }}
				        	</span>
				        </v-tooltip>
				     </v-btn>
            	</template>
            	 <v-btn-toggle mandatory>
	       		
   				    <v-btn 
   				    	small 
   				    	@click = "render_grid('8')" 
   				    > <!-- @click="send_grid('view_grid')" -->
       					<v-icon 
       						small
       					>
       						mdi-view-grid
       					</v-icon>
       					<span
       						v-text = "'4x4'"
       					></span>		
   				    </v-btn>
       			
       				<!-- <v-btn 
       					small 
       					@click="render_grid('view_compact')"
       				> 
       				@click="send_grid('view_compact')"       					
						<v-icon 
							small 
						>mdi-view-compact</v-icon>
       				</v-btn>
			
       				<v-btn 
       					small 
       					@click="render_grid('view_quilt')"
       				> 
       				@click="send_grid('view_quilt')"
						<v-icon 
							small
						>mdi-view-quilt</v-icon>
       				</v-btn> -->
				
				</v-btn-toggle>
       	
    		</v-menu>	
	</v-bottom-navigation>
</template>
<script>
	import EventBus from '@/event-bus'
	export default{
		name: 'grid_paging',
		data:() => ({
			pagination : {
				visible : 6,
				total 	: 1,			
				items 	: 8,
				found 	: true,
			},
			page 	   : 1,
		}), // data

		watch:{
			page: {
				handler(){

					EventBus.$emit('page', this.page);
				}, deep: true
			}, // pagination
		}, // watch

		methods: {
			render_grid(key){
				console.log(key, 'grids')
			}, // render grid
		}, // methods
		
		mounted(){
			// Cargar configuración de paginación desde localStorage
			if (localStorage.getItem('pagination_layout')) {
				const paginationConfig = JSON.parse(localStorage.getItem('pagination_layout'));
				this.pagination = { ...this.pagination, ...paginationConfig };
			}
			
			EventBus.$on('pagination', (action) => {
				let lent = action.length;
				this.pagination.total = lent - 1;
			})
		}, // mounted
		beforeDestroy(){
			// Limpiar EventBus listeners
			EventBus.$off('pagination');
		}
	};
</script>